import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { INavigationData } from 'us.collection/interfaces';
import { ManageCreditorInformation } from "us.collection.creditor/components/ManageCreditors";

interface ICnt_EditCreditorInfo {
  caseNo: number;
}

const Cnt_EditCreditorInfo: React.FC<ICnt_EditCreditorInfo> = (props) => {
  const navigate  = useNavigate();
  const location = useLocation();
  const state = location.state as INavigationData;
  const onMinimize = () => {
    navigate(`/case/${props.caseNo}`, { state });
  };
  return <ManageCreditorInformation onMinimize={onMinimize} {...props} />;
};

export default Cnt_EditCreditorInfo;
